import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { Navigation } from './components/Navigation';
import { Home } from './pages/Home';
import { Products } from './pages/Products';
import { ProductDetail } from './pages/ProductDetail';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { Confirmation } from './pages/Confirmation';
import { About } from './pages/About';
import { BulkOrders } from './pages/BulkOrders';
import { TrackOrder } from './pages/TrackOrder';
import { Admin } from './pages/Admin';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { Toaster } from './components/ui/sonner';
import './App.css';

const TOAST_OPTIONS = {
  style: {
    background: '#FFF8F0',
    border: '1px solid rgba(201, 169, 110, 0.5)',
    color: '#2D4A2D',
    fontFamily: 'Lato, sans-serif',
    fontSize: '15px',
    padding: '16px 20px',
    borderRadius: '4px',
    boxShadow: '0 8px 32px rgba(74, 124, 59, 0.12)',
  },
};

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <div className="App min-h-screen bg-brand-cream">
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/confirmation" element={<Confirmation />} />
            <Route path="/about" element={<About />} />
            <Route path="/bulk-orders" element={<BulkOrders />} />
            <Route path="/track-order" element={<TrackOrder />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <ExitIntentPopup />
          <Toaster
            position="top-center"
            duration={2500}
            toastOptions={TOAST_OPTIONS}
          />
        </div>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
